import client from '@/services/';

const state = () => ({
    all: [],
    one: {}
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAll(cxt) {
        let data = await client.get('typeFile/all');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', name, extension, type, code} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(name && { name }),
            ...(extension && { extension }),
            ...(type && { type }),
            ...(code && { code }),
        }).toString();
        let { data } = await client.get(`typeFile?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getTypeCategorie(cxt, id) {
        let data  = await client.get('typeFile/all/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('typeFile/edit/'+payload.id, payload) : await client.post('typeFile/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
    
        return data;    },
    async del(cxt, id) {
        let { data } = await client.delete('typeFile/delete/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async exportToExcel({ commit }, params = {}) {
        try {
            const { name, extension, type, code } = params;
            const queryParams = new URLSearchParams({
                ...(name && { name }),
                ...(extension && { extension }),
                ...(type && { type }),
                ...(code && { code }),
            }).toString();
            
            const url = queryParams ? `typeFile/export/excel?${queryParams}` : 'typeFile/export/excel';
            const response = await client.get(url, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
